import { useQueryClient } from "@tanstack/react-query";
import { $api } from "../generated/client";

/**
 * Reads the admin panel address when asked (a click), never at render: only
 * super admins are served it, and it is not in any bundle. Cached for a few
 * minutes; `null` when the backend has none configured.
 */
export function useFetchAdminPanelUrl() {
  const queryClient = useQueryClient();
  return async (): Promise<string | null> => {
    const { url } = await queryClient.fetchQuery(
      $api.queryOptions(
        "get",
        "/super-admin/admin-panel-url",
        {},
        { staleTime: 5 * 60 * 1000 },
      ),
    );
    return url ?? null;
  };
}
